import { api } from '../../../api/axios'
import type { Arma, ArmaFilters } from '../types'

export interface ListResponse<T> {
  data: T[]
  meta: { total: number; page: number; limit: number; totalPages: number }
}

export const armaService = {
  list: (filters: ArmaFilters = {}) =>
    api.get<ListResponse<Arma>>('/armas', { params: filters }).then(r => r.data),

  getById: (id: number) =>
    api.get<{ data: Arma }>(`/armas/${id}`).then(r => r.data.data),

  create: (data: Omit<Arma, 'idarma' | 'atirador_nome'>) =>
    api.post<{ data: Arma }>('/armas', data).then(r => r.data.data),

  update: (id: number, data: Partial<Omit<Arma, 'idarma' | 'atirador_nome'>>) =>
    api.put<{ data: Arma }>(`/armas/${id}`, data).then(r => r.data.data),

  delete: (id: number) =>
    api.delete(`/armas/${id}`),
}
